<footer class="lco-nav">
  <button *ngIf="(menuType$ | async) === 'master'"
          mat-button color="primary"
          class="action-btn action-btn--table"
          (click)="manageTable()"
          [disabled]="loading">
    <span class="action-icon icon--table"></span>
    <span class="action-text">{{ 'tableStr' | translate }}</span>
  </button>

  <button *ngIf="(menuType$ | async) === 'master'"
          mat-button color="primary"
          class="action-btn action-btn--friend"
          (click)="addFriend()"
          [disabled]="loading">
    <span class="action-icon icon--add"></span>
    <span class="action-text">{{ 'addFriendStr' | translate }}</span>
  </button>

  <button mat-button color="primary"
          class="action-btn action-btn--order"
          (click)="orderFlow()"
          [disabled]="loading">
    <span class="action-icon icon--order"></span>
    <span class="action-text">{{ 'orderStr' | translate }}</span>
  </button>
  <button mat-button color="primary"
          class="action-btn action-btn--pay"
          (click)="payFlow()"
          [disabled]="loading">
    <span class="action-icon icon--dollar"></span>
    <span class="action-text">{{ 'payStr' | translate }}</span>
  </button>

  <button mat-button color="primary"
          class="action-btn action-btn--chat"
          (click)="openChatBot()"
          [disabled]="loading">
    <span class="action-icon icon--chat"></span>
    <span class="action-text">{{ 'askJackStr' | translate }}</span>
  </button>
</footer>
